import React from "react";
import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
} from "@mui/material";
import {REGIONS} from "src/constants/Regions";

interface RegionSelectorProps {
    region: string;
    onChange: (event: SelectChangeEvent) => void;
}

const RegionSelector: React.FC<RegionSelectorProps> = ({ region, onChange }) => {
    return (
        <Box mt={3} mb={3} display="flex" justifyContent="center">
            <FormControl sx={{ width: 300 }}>
                <InputLabel
                    id="region-label"
                    sx={{ top: '-4px' }}
                >
                    Select Region
                </InputLabel>
                <Select
                    labelId="region-label"
                    value={region}
                    label="Select Region"
                    onChange={onChange}
                    sx={{ height: 46,
                        textAlign: "left",
                    }}
                >
                    {REGIONS.map((region) => (
                        <MenuItem key={region.value} value={region.value}>
                            {region.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

export default RegionSelector;
